import { useEffect, useState } from 'react';
import { isConfigured, supabase } from '../sync/supabase';

export interface SessionState {
  /** null when signed out, or when there is no backend configured at all. */
  userId: string | null;
  /** True until the persisted session has been read from storage. */
  loading: boolean;
}

/**
 * One user, permanently signed in. The session is restored from storage on
 * every launch and refreshed in the background, so the sign-in screen is
 * something you see once per device and then never again.
 */
export function useSession(): SessionState {
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(isConfigured);

  useEffect(() => {
    if (!supabase) return;

    void supabase.auth.getSession().then(({ data }) => {
      setUserId(data.session?.user.id ?? null);
      setLoading(false);
    });

    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      setUserId(session?.user.id ?? null);
      setLoading(false);
    });

    return () => data.subscription.unsubscribe();
  }, []);

  return { userId, loading };
}
